import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageSpecialRequestsList extends PageList {
	constructor() {
		super();
	}

	init($data) {
		super.init($data);

		$(".jsBtnExcel").on("click", this.onCreateExcel.bind(this))

	}

	initList() {
		// h
		let h = this.getAvailableHeight();
		

		//
		this.theGrid = new GridWrapper($(".jsList"));

		let options = {
			dataSource: {
				// data: $data.rows,
			},
			sorting: {
				multiple: false,
				allowUnsort: false
			},
			paging: {
				pageSize: 12,
				pageLinksCount: 10
			},
			rowHover: false,
			altRows: false,
			selection: {
				type: "row",
				multiple: false,
				toggle: true,
			},
			columns: [
				{
					field: "ReceiptId",
					title: "Numero Richiesta"
				},
				{
					field: "Date",
					title: "Data Richiesta"
				},
				{
					field: "TypeLabel",
					title: "Tipo"
				},
				{
					field: "UidLookupSpecialrequestStatusLabel",
					title: "Stato"
				},
				{
					field: "RecordUsrInsert",
					title: "Email"
				},
				{
					field: "CustomerId",
					title: "CustomerId"
				},
				{
					field: "CustomerName",
					title: "CustomerName"
				},
				//{
				//	title: "ACTION",
				//	width: "150px",
				//	// field: "_idx",
				//	columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
				//}
			],
			events: {
				selectionChanged: this.openDetailPage.bind(this)
			},
			scrolling: true,
			resizing: true,
			height: h+"px"
		}

		this.theGrid.create(options, this.data.rows);
		this.theGrid.enableSearch($(".jsListSearch"), {
			or: [
				{ path: "RecordUsrInsert", filter: "contains", value: "" },
				{ path: "Date", filter: "contains", value: "" },
				{ path: "ReceiptId", filter: "contains", value: "" },
				{ path: "UidLookupSpecialrequestStatusLabel", filter: "contains", value: "" },
				{ path: "TypeLabel", filter: "contains", value: "" },
				{ path: "CustomerId", filter: "contains", value: "" },
				{ path: "CustomerName", filter: "contains", value: "" }
			]
		});
		this.theGrid.init("jsList");
		// var a = StateManager.getViewState("jsList")
		jQuery(window).on("resize.grid", this.onResize.bind(this));

		return;
	}

	openDetailPage(ev) {
		try {
			let indexClicked = ev.indices[0];
			let data = ev.target.dataSource.data[indexClicked];
			this.indexClicked = indexClicked
			let args = StateManager._splitUrl(document.location.href);
			document.location.href = TheApp.Env.BaseUrlNls + "specialrequest/detail/" + Base64.toBase64(data.Uid, true) + "?__pi=" + this.data.page.PageId;
		}
		catch (ex) {

		}
	}

	getAvailableHeight() {
		let a = jQuery(".js-size");
		let i = 0;
		for (let x = 0; x < a.length; x++) {
			i += jQuery(a[x]).outerHeight();
		}
		i += 50; // padding app container
		i += 78; // search box
		i += 143; // paging
		let h = jQuery(window).height() - i;
		return h;
	}

	onResize(e) {
		//debugger;
		this.theGrid.setHeight(this.getAvailableHeight());
	}

	onAdd() {
		let args = StateManager._splitUrl(document.location.href);
		document.location.href = TheApp.Env.BaseUrlNls + "users/detail?_pi=" + encodeURIComponent(args.qPart["_pi"]);
	}

	onCreateExcel() {
		let s = $.trim($(".jsListSearch").val())
		window.open(TheApp.Env.BaseUrlNls + "specialrequest/excel?search=" + Base64.toBase64(s, true), "_blank");
	}


}

